export const setEventDataTableAppTypeFilter = payload => {
  return {
    type: "SET_EVENT_DATATABLE_APP_TYPE_FILTER",
    payload
  };
}

export const getEventStatsDataTable = payload => {
  return {
    type: "GET_DATA_TABLE_EVENT_STATS",
    payload
  };
}

export const setEventStatsYear = payload => {

  return {
    type: "SET_EVENT_STATS_YEAR_FILTER",
    payload
  };
}



export const setEventStatsSearchFilter = payload => {
  return {
    type: "SET_EVENT_STATS_SEARCH_FILTER",
    payload
  };
}


export const setEventStatsPageSize = payload => {
  return {
    type: "SET_EVENT_STATS_PAGE_SIZE",
    payload
  };
};

export const setEventStatsPageCurrent = payload => {
  return {
    type: "SET_EVENT_STATS_PAGE_CURRENT",
    payload
  };
};

export const countEventAppType = payload => {
  return {
    type: "COUNT_EVENT_STATS_APP_TYPE",
    payload
  };
};

export const getGlobalEventStats = payload => {
  return {
    type: "GET_GLOBAL_EVENT_STATS",
    payload
  };
};

export const setEventStatsLanguage = payload => {
  return {
    type: "SET_EVENT_STATS_LANGUAGE",
    payload
  };
};

export const setEventStatsStartMonth = payload => {
  return {
    type: "SET_EVENT_STATS_START_MONTH",
    payload
  };
};

export const setEventStatsEndMonth = payload => {
  return {
    type: "SET_EVENT_STATS_END_MONTH",
    payload
  };
};

export const setEventStatsStartOptions = payload => {
  return {
    type: "SET_EVENT_STATS_START_OPTIONS",
    payload
  };
};

export const setEventStatsEndOptions = payload => {
  return {
    type: "SET_EVENT_STATS_END_OPTIONS",
    payload
  };
};

export const setMonthMenus = payload => {
  return {
    type: "SET_MONTH_MENUS",
    payload
  };
};


export const getSeasonsValues = payload => {
  return {
    type: "GET_SEASONS_VALUES",
    payload
  };
};

export const setEventStatsSaison = payload => {
  return {
    type: "SET_SEASON",
    payload
  };
};

export const setActivitiesOrder = payload => {
  return {
    type: "SET_ACTIVITIES_ORDER",
    payload
  };
};

export const fetchRegistrantLineChartCAData = payload => {
  return {
    type: "GET_DATA_CHART_EVENT_STATS",
    payload
  };
}

export const fetchRegistrantLineChartData = payload => {
  return {
    type: "GET_DATA_CHART_EVENT_STATS",
    payload
  };
}

export const setBudgetAppTypeFilter = payload => {
  return {
    type: "SET_BUDGET_TYPE_FILTER",
    payload
  };
}

export const setBudgetYearFilter = payload => {

  return {
    type: "SET_BUDGET_YEAR_FILTER",
    payload
  };
}

export const setBudgetReccurenceCoeff = payload => {

  return {
    type: "SET_BUDGET_YEAR_RECCURENCE_COEFF",
    payload
  };
}

export const setBudgetRegistrantsCount = payload => {

  return {
    type: "SET_BUDGET_REGISTRANTS_COUNT",
    payload
  };
}

export const setPricePerUnit = payload => {

  return {
    type: "SET_PRICE_PER_UNIT",
    payload
  };
}

export const setRegistrantNumber = payload => {

  return {
    type: "SET_REGISTRANT_NUMBER",
    payload
  };
}

export const setShowRealizedBudget = payload => {
  return {
    type: "SET_SHOW_REALIZED_BUDGET",
    payload
  };
}

export const updateRegistrantsCountPerMonth = (index, value, appType) => {
  return {
    type: "UPDATE_REGISTRANTS_COUNT_PER_MONTH",
    payload: { index, value, appType}
  };
};

export const updateRegistrantsCountPerTargetBudget = (newRegistrantsCount, appType) => {
  return {
    type: "UPDATE_REGISTRANTS_COUNT_PER_REGISTRANT_COUNT",
    payload: { newRegistrantsCount, appType}
  };
};

export const updateRegistrantsCountPerPrice = (newPricePerUnit) => {
  return {
    type: "UPDATE_REGISTRANTS_COUNT_PER_PRICE",
    payload: {newPricePerUnit}
  };
};

export const updateFollowUpRegistrantsCountPerMonth = (index, value) => {
  return {
    type: "UPDATE_FOLLOW_UP_REGISTRANTS_COUNT_PER_MONTH",
    payload: { index, value}
  };
};

export const updateFollowUpPricePerUnit = (index, value) => {
  return {
    type: "UPDATE_FOLLOW_UP_PRICE_PER_UNIT",
    payload: { index, value}
  };
};

export const setOriginalValues = payload => {
  return {
    type: "SET_ORIGINAL_VALUES",
    payload
  };
};

export const fetchBudgetData = payload => {
  return {
    type: "FETCH_BUDGET_DATA",
    payload
  };
}

export const generateFollowUp = payload => {
  return {
    type: "GENERATE_FOLLOW_UP",
    payload
  };
}

export const updateFollowUp = payload => {
  return {
    type: "UPDATE_FOLLOW_UP",
    payload
  };
}

export const checkAppTypesConfiguration = payload => {
  return {
    type: "CHECK_APP_TYPES_CONFIGURATION",
    payload
  };
}

export const deleteBudgetConfiguration = payload => {
  return {
    type: "DELETE_BUDGET_CONFIGURATION",
    payload
  };
}

export const updateConfiguration = payload => {
  return {
    type: "UPDATE_CONFIGURATION",
    payload
  };
}

export const updateSetUp = payload => {
  return {
    type: "UPDATE_SET_UP",
    payload
  };
}







// WEBPACK FOOTER //
// ./app/actions/actions/eventStats.js